import {stickyElement} from "./utilities/sticky";

export function stickyHeader(headerArea = document.querySelector('.headerMain'), headerTrigger = document.getElementById('headerStickyTrigger'), isMobile = true) {
    if (headerArea) {
        stickyElement(headerArea, headerTrigger, true, isMobile);
    }
}